import * as React from "react";
import {
  useMappedState,
  useDispatch
} from "redux-react-hook";
import * as H from "history";
import _ from "lodash";

import { useNotificationBannerContext } from "src/core/shared/context//NotificationBanner/NotificationBannerContext";
import { useDrop } from "src/core/drops/hooks";
import { useCurrentUser } from "src/core/users/hooks";
import { IStore } from "src/core/shared/store";
import { formatDropName } from "src/core/drops/utils/format-drop-name";

import {
  setGlobalRole,
  setMasqueradeMode
} from "../store/global/global.actions";

const bannerId = "masquerade-mode";

/**
 * NOTE: this hook is set up to be used outside of the router
 */
export const useMasqueradeModeNotification = (history: H.History<any>) => {
  const {
    notify, banners, hideBanner
  } = useNotificationBannerContext();

  const { masqueradeMode } = useMappedState(({ global }: IStore) => ({ masqueradeMode: global.masqueradeMode }));
  const dispatch = useDispatch();
  const [ { currentRole } ] = useCurrentUser();
  const [ { drop } ] = useDrop();

  // On drop change
  React.useEffect(() => {
    const hasMasqueradeModeBanner = _.find(banners, banner => banner.id === bannerId);

    if (hasMasqueradeModeBanner) {
      if (!masqueradeMode?.active) {
        hideBanner(bannerId);
      } else {
        return;
      }
    } else {
      if (masqueradeMode?.active) {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const message = `You are currently masquerading as ${formatDropName(drop!)}`;

        notify({
          id: bannerId,
          dismissible: false,
          duration: 0,
          message,
          type: "notice",
          button: {
            label: "Exit Masquerade Mode",
            onClick: () => {
              const { redirect, initialRole } = masqueradeMode;

              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              dispatch(setGlobalRole(initialRole!));
              dispatch(setMasqueradeMode({ active: false }));
              history.push(redirect as H.LocationDescriptor);
            }
          }
        });
      }
    }

    if (hasMasqueradeModeBanner) {
      if (!_.find(banners, banner => banner.id === "masquerade-mode")) {
        notify;
      }
    }
  }, [
    banners,
    currentRole?.type,
    dispatch,
    drop,
    hideBanner,
    history,
    masqueradeMode,
    notify
  ]);
};
